import { Model } from '../model/model.class';

export class SoftwareVersion extends Model {

  public softwareVersionId: number;
  public softwareType: string;
  public softwareName: string;
  public versionNumber: number;
  public description: string;
  public fileStatus: string;

  constructor() {super(); }

}



// WEBPACK FOOTER //
// ./src/app/model/softwareVersion.class.ts